<span matSnackBarLabel>
	<span class="snack-bar-label">
		{{ snackBarData.label ?? "Error" }}

		<ul class="snack-bar-errors body-small">
			@for (item of snackBarData.items; track $index) {
				<li>
					@if (item.title) {
						<span class="bold">{{ item.title }}:</span>
					}
					{{ item.message }}
				</li>
			}
		</ul>
	</span>
</span>

<span matSnackBarActions>
	<button
		matIconButton
		matSnackBarAction
		type="button"
		(click)="snackBarRef.dismissWithAction()"
	>
		<mat-icon>close</mat-icon>
	</button>
</span>
